import cn from '../../../../../common/className.js'

export default function ListItem({children, className}) {
  return (
    <div className={cn`list__item--order-data ${className}`}>{children}</div>
  )
}
